var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessageNotif(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/outline/message-notif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 4.375A3.375 3.375 0 1119.375 1a3.375 3.375 0 013.375 3.375z",
    fill: "#f15223"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M12 22.81a2.265 2.265 0 01-1.8-.96l-1.5-2a.377.377 0 00-.21-.1H8c-4.17 0-6.75-1.13-6.75-6.75V8c0-4.42 2.33-6.75 6.75-6.75h6a.755.755 0 01.75.75.755.755 0 01-.75.75H8C4.42 2.75 2.75 4.42 2.75 8v5c0 4.52 1.55 5.25 5.25 5.25h.5a1.876 1.876 0 011.4.7l1.5 2a.694.694 0 001.2 0l1.5-2a1.752 1.752 0 011.4-.7h.5c3.58 0 5.25-1.67 5.25-5.25v-3a.75.75 0 011.5 0v3c0 4.42-2.33 6.75-6.75 6.75h-.5a.261.261 0 00-.2.1l-1.5 2a2.265 2.265 0 01-1.8.96z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M12 12a1 1 0 111-1 1 1 0 01-1 1zM16 12a1 1 0 111-1 1 1 0 01-1 1zM8 12a1 1 0 111-1 1 1 0 01-1 1z",
    fill: "#292d32"
  }))));
}
export default SvgVuesaxOutlineMessageNotif;